import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async razCampagne() {
    await axios.post("/api/admin/razCampagne");
  },
};
